var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKerve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 40,
    viewBox: "0 0 155 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2308 2.19725H152.769V37.8027H2.2308V2.19725ZM0 40H155V0H0V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4782 28.3945L18.7694 21.2934L17.2686 23.0312V28.3945H14.2773V11.6055H17.2686V19.5855L23.9408 11.6055H27.6419L20.7162 19.5056L28.1793 28.3945H24.4782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9229 28.3945V11.6055H54.6041V14.2022H45.9141V18.5268H54.4317V21.1236H45.9141V25.8077H54.6041V28.3945H42.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1973 28.3945L76.4455 22.1223H73.4542V28.3945H70.4629V11.6055H77.9563C81.333 11.6055 83.5536 13.7428 83.5536 16.8689C83.5536 19.8452 81.556 21.4731 79.4875 21.8027L83.6753 28.3945H80.1973ZM80.4711 16.8389C80.4711 15.2309 79.2441 14.1922 77.5609 14.1922H73.4441V19.5256H77.5609C79.2441 19.5356 80.4711 18.4769 80.4711 16.8389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.803 28.3945L97.1104 11.6055H100.507L105.669 25.1785L110.83 11.6055H114.237L107.534 28.3945H103.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.042 28.3945V11.6055H140.723V14.2022H132.033V18.5268H140.541V21.1236H132.033V25.8077H140.723V28.3945H129.042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKerve);
export default __webpack_public_path__ + "static/media/kerve.cf6559a142b5f56e6c08b3459832305a.svg";
export { ForwardRef as ReactComponent };